import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import PointsLayer from "../components/PointsLayer";

const PointsPage = () => {
    return (
        <MasterLayout>
            <PointsLayer />
        </MasterLayout>
    );
};

export default PointsPage;
